var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"p-3 mt-2"},[_c('div',{staticClass:"shadow h-full p-3 rounded-lg"},[_c('h3',{staticClass:"text-gray-dark font-bold text-md mb-3"},[_vm._v("Post")]),_c('UserPostList',{attrs:{"data":_vm.posts,"handlePostLike":_vm.handlePostLike}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }